import { render, staticRenderFns } from "./NuvemShopOauth.vue?vue&type=template&id=90273e30&scoped=true&"
import script from "./NuvemShopOauth.vue?vue&type=script&lang=js&"
export * from "./NuvemShopOauth.vue?vue&type=script&lang=js&"
import style0 from "./NuvemShopOauth.vue?vue&type=style&index=0&id=90273e30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90273e30",
  null
  
)

export default component.exports